const staticPageInitialState = {
	contactPage: {},
};

export default staticPageInitialState;